// extracted by mini-css-extract-plugin
var _1 = "SlantContainer__mainBorder--xXvu0";
var _2 = "SlantContainer__slant--_SiTA";
export { _1 as "mainBorder", _2 as "slant" }
